export default "__VITE_ASSET__LkOgnlaF__"